/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Success_TitleInputs */

const en_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaration received`)
};

const de_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklärung eingegangen`)
};

const fr_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déclaration reçue`)
};

const es_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaración recibida`)
};

const it_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichiarazione ricevuta`)
};

const nl_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verklaring ontvangen`)
};

const pl_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oświadczenie otrzymane`)
};

const fi_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitus vastaanotettu`)
};

const da_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklæring modtaget`)
};

const sv_consumer_declaration_success_title = /** @type {(inputs: Consumer_Declaration_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förklaring mottagen`)
};

/**
* | output |
* | --- |
* | "Declaration received" |
*
* @param {Consumer_Declaration_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_success_title = /** @type {((inputs?: Consumer_Declaration_Success_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Success_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_success_title(inputs)
	if (locale === "fr") return fr_consumer_declaration_success_title(inputs)
	if (locale === "es") return es_consumer_declaration_success_title(inputs)
	if (locale === "it") return it_consumer_declaration_success_title(inputs)
	if (locale === "nl") return nl_consumer_declaration_success_title(inputs)
	if (locale === "pl") return pl_consumer_declaration_success_title(inputs)
	if (locale === "fi") return fi_consumer_declaration_success_title(inputs)
	if (locale === "da") return da_consumer_declaration_success_title(inputs)
	if (locale === "sv") return sv_consumer_declaration_success_title(inputs)
	return en_consumer_declaration_success_title(inputs)
});